import { render, staticRenderFns } from "./BotaoDuvidas.vue?vue&type=template&id=03ec59ce&"
import script from "./BotaoDuvidas.vue?vue&type=script&lang=js&"
export * from "./BotaoDuvidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports